@let f = query();
@let s = summary();
<div #specificContainer class="iu-specific-window audit" [attr.data-cy-specific-window-name]="name">
  <!-- title (specific window style) and toolbar: period, live refresh, refresh -->
  <h1>{{ name || ('audit.title' | translate) }}</h1>
  <div class="audit-toolbar" role="toolbar" [attr.aria-label]="'audit.period.label' | translate">
    <div class="audit-periods" role="radiogroup" [attr.aria-label]="'audit.period.label' | translate">
      @for (p of periods; track p) {
        <button
          type="button"
          role="radio"
          class="p-button audit-period"
          [class.p-button-primary]="f.period === p"
          [class.p-button-secondary]="f.period !== p"
          [attr.aria-checked]="f.period === p"
          (click)="setPeriod(p)">
          {{ 'audit.period.' + p | translate }}
        </button>
      }
    </div>
    @if (f.period === 'custom') {
      <div class="audit-range">
        <iu-calendar-ui
          class="audit-range-field"
          [isStandalone]="true"
          [data]="timeField"
          [locale]="locale"
          [label]="'audit.period.from' | translate"
          [fieldValue]="customFrom()"
          (fieldValueModified)="setCustomBound('from', $any($event))" />
        <iu-calendar-ui
          class="audit-range-field"
          [isStandalone]="true"
          [data]="timeField"
          [locale]="locale"
          [label]="'audit.period.to' | translate"
          [fieldValue]="customTo()"
          (fieldValueModified)="setCustomBound('to', $any($event))" />
      </div>
    }
    <span class="audit-toolbar-spacer"></span>
    <span class="audit-sub" [title]="'audit.period.timeZone' | translate">
      {{ 'audit.period.showing' | translate: { from: fmt().dateTime(range().from.toISOString()), to: fmt().dateTime(range().to.toISOString()) } }}
      <span class="audit-tz">{{ fmt().timeZone }}</span>
    </span>
    <label class="audit-live" [title]="'audit.live.help' | translate">
      <input type="checkbox" [checked]="live()" (change)="live.set($any($event.target).checked)" />
      <span class="audit-live-dot" [class.audit-live-dot--on]="live() && anyRunning()" aria-hidden="true"></span>
      {{ 'audit.live.label' | translate }}
    </label>
    <button type="button" class="p-button p-button-secondary audit-icon-btn" (click)="reload()" [attr.aria-label]="'audit.actions.refresh' | translate" [title]="'audit.actions.refresh' | translate">
      <i class="fa-solid fa-rotate-right" aria-hidden="true"></i>
    </button>
  </div>

  <!-- overview: metrics of the period -->
  <section class="audit-cards" [attr.aria-busy]="summaryState() === 'loading'" [attr.aria-label]="'audit.overview' | translate">
    @if (summaryState() === 'error') {
      <p class="aud-state aud-state--error audit-cards-error">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>{{ 'audit.state.summaryError' | translate }}
        <button type="button" class="aud-link-btn" (click)="reload()">{{ 'audit.actions.retry' | translate }}</button>
      </p>
    } @else {
      <button type="button" class="audit-card" (click)="showExecutions([])">
        <span class="audit-card-label"><i class="fa-solid fa-gears" aria-hidden="true"></i>{{ 'audit.cards.executions' | translate }}</span>
        <span class="audit-card-value">{{ s ? fmt().number(s.executions) : '...' }}</span>
        <span class="audit-card-sub">{{ s ? ('audit.cards.completed' | translate: { count: fmt().number(s.completed) }) : '' }}</span>
      </button>
      <button type="button" class="audit-card audit-card--failed" [class.audit-card--zero]="s && s.failed + s.cancelled === 0" (click)="showExecutions(['F', 'C'])">
        <span class="audit-card-label"><i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>{{ 'audit.cards.failed' | translate }}</span>
        <span class="audit-card-value">{{ s ? fmt().number(s.failed) : '...' }}</span>
        <span class="audit-card-sub">{{ s && s.cancelled ? ('audit.cards.cancelled' | translate: { count: fmt().number(s.cancelled) }) : '' }}</span>
      </button>
      <button type="button" class="audit-card audit-card--running" [class.audit-card--zero]="s && s.runningNow === 0" (click)="showExecutions(['R'])">
        <span class="audit-card-label"><i class="fa-solid fa-circle-play" aria-hidden="true"></i>{{ 'audit.cards.running' | translate }}</span>
        <span class="audit-card-value">{{ s ? fmt().number(s.runningNow) : '...' }}</span>
        <span class="audit-card-sub">{{ 'audit.cards.runningSub' | translate }}</span>
      </button>
      <button type="button" class="audit-card" (click)="showChanges([])">
        <span class="audit-card-label"><i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>{{ 'audit.cards.changes' | translate }}</span>
        <span class="audit-card-value">{{ s ? fmt().number(s.changes) : '...' }}</span>
        <span class="audit-card-sub">
          @if (s) {
            {{ 'audit.cards.changesSplit' | translate: { i: fmt().number(s.inserts), u: fmt().number(s.updates), d: fmt().number(s.deletes) } }}
          }
        </span>
      </button>
      @if (!s || s.documentReads >= 0) {
        <button type="button" class="audit-card" (click)="showDocuments([])">
          <span class="audit-card-label"><i class="fa-solid fa-folder-open" aria-hidden="true"></i>{{ 'audit.cards.documents' | translate }}</span>
          <span class="audit-card-value">{{ s ? fmt().number(s.documentReads) : '...' }}</span>
          <span class="audit-card-sub">{{ s ? ('audit.cards.downloads' | translate: { count: fmt().number(s.documentDownloads) }) : '' }}</span>
        </button>
      }
    }
  </section>
  @if (s && (s.executionsSince || s.changesSince)) {
    <p class="audit-retention">
      <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
      @if (s.executionsSince) {
        <span [title]="fmt().exact(s.executionsSince)">{{ 'audit.retention.executions' | translate: { date: fmt().date(s.executionsSince) } }}</span>
      }
      @if (s.changesSince) {
        <span [title]="fmt().exact(s.changesSince)">{{ 'audit.retention.changes' | translate: { date: fmt().date(s.changesSince) } }}</span>
      }
    </p>
  }

  <!-- tabs -->
  <div class="audit-tabs" role="tablist" [attr.aria-label]="'audit.title' | translate">
    <button type="button" role="tab" id="audit-tab-executions" class="audit-tab" [class.audit-tab--on]="f.tab === 'executions'" [attr.aria-selected]="f.tab === 'executions'" aria-controls="audit-panel" (click)="setTab('executions')">
      <i class="fa-solid fa-gears" aria-hidden="true"></i>{{ 'audit.tabs.executions' | translate }}
      @if (s) {<span class="aud-count">{{ fmt().number(s.executions) }}</span>}
    </button>
    <button type="button" role="tab" id="audit-tab-changes" class="audit-tab" [class.audit-tab--on]="f.tab === 'changes'" [attr.aria-selected]="f.tab === 'changes'" aria-controls="audit-panel" (click)="setTab('changes')">
      <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>{{ 'audit.tabs.changes' | translate }}
      @if (s) {<span class="aud-count">{{ fmt().number(s.changes) }}</span>}
    </button>
    <button type="button" role="tab" id="audit-tab-documents" class="audit-tab" [class.audit-tab--on]="f.tab === 'documents'" [attr.aria-selected]="f.tab === 'documents'" aria-controls="audit-panel" (click)="setTab('documents')">
      <i class="fa-solid fa-folder-open" aria-hidden="true"></i>{{ 'audit.tabs.documents' | translate }}
      @if (s && s.documentReads >= 0) {<span class="aud-count">{{ fmt().number(s.documentReads) }}</span>}
    </button>
    <span class="audit-tabs-spacer"></span>
    <div class="audit-export">
      <button type="button" class="p-button p-button-secondary audit-export-btn" [disabled]="exporting() || !pageInfo()" (click)="export('csv')" [title]="'audit.export.help' | translate">
        <i class="fa-solid" [class]="exporting() ? 'fa-circle-notch fa-spin' : 'fa-file-csv'" aria-hidden="true"></i>CSV
      </button>
      <button type="button" class="p-button p-button-secondary audit-export-btn" [disabled]="exporting() || !pageInfo()" (click)="export('json')" [title]="'audit.export.help' | translate">
        <i class="fa-solid fa-file-code" aria-hidden="true"></i>JSON
      </button>
    </div>
  </div>

  <div class="audit-main" [class.audit-main--detail]="detailOpen()">
    <section id="audit-panel" class="audit-panel" role="tabpanel" [attr.aria-labelledby]="'audit-tab-' + f.tab">
      <!-- filters -->
      <div class="audit-filters">
        <label class="audit-search">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          <span class="visually-hidden">{{ 'audit.filters.search' | translate }}</span>
          <input
            #search
            type="search"
            class="p-inputtext aud-input"
            [placeholder]="(f.tab === 'executions' ? 'audit.filters.searchExecutions' : f.tab === 'changes' ? 'audit.filters.searchChanges' : 'audit.filters.searchDocuments') | translate"
            [value]="f.q"
            (input)="onSearch(search.value)" />
        </label>
        @if (f.tab === 'executions') {
          <div class="audit-chips" role="group" [attr.aria-label]="'audit.filters.status' | translate">
            @for (st of statuses; track st) {
              <button type="button" class="audit-chip audit-chip--{{ st }}" [class.audit-chip--on]="f.status.includes(st)" [attr.aria-pressed]="f.status.includes(st)" (click)="toggleStatus(st)">
                <span class="audit-dot audit-dot--{{ st }}" aria-hidden="true"></span>{{ 'audit.status.' + st | translate }}
              </button>
            }
          </div>
          <label class="audit-field">
            <span>{{ 'audit.filters.type' | translate }}</span>
            <select class="p-inputtext aud-input" [value]="f.type ?? ''" (change)="setType($any($event.target).value)">
              <option value="">{{ 'audit.filters.any' | translate }}</option>
              <option value="P">{{ 'audit.type.P' | translate }}</option>
              <option value="R">{{ 'audit.type.R' | translate }}</option>
            </select>
          </label>
          <iu-audit-option-picker class="audit-field audit-field--wide" kind="process" [label]="'audit.filters.process' | translate" [selectedName]="nameOf('process', f.processId)" (picked)="pickOption('process', $event)" />
        } @else if (f.tab === 'documents') {
          <div class="audit-chips" role="group" [attr.aria-label]="'audit.filters.action' | translate">
            @for (a of docActions; track a) {
              <button type="button" class="audit-chip" [class.audit-chip--on]="f.action.includes(a)" [attr.aria-pressed]="f.action.includes(a)" (click)="toggleAction(a)" [title]="a === 'THUMBNAIL' ? ('audit.docAction.thumbnailHelp' | translate) : ''">
                <span class="audit-dot audit-dot--doc-{{ a }}" aria-hidden="true"></span>{{ 'audit.docAction.' + a | translate }}
              </button>
            }
          </div>
        } @else {
          <div class="audit-chips" role="group" [attr.aria-label]="'audit.filters.operation' | translate">
            @for (op of operations; track op) {
              <button type="button" class="audit-chip audit-chip--op-{{ op }}" [class.audit-chip--on]="f.operation.includes(op)" [attr.aria-pressed]="f.operation.includes(op)" (click)="toggleOperation(op)">
                <span class="audit-dot audit-dot--op-{{ op }}" aria-hidden="true"></span>{{ 'audit.operation.' + op | translate }}
              </button>
            }
          </div>
          <iu-audit-option-picker class="audit-field audit-field--wide" kind="table" [label]="'audit.filters.table' | translate" [selectedName]="nameOf('table', f.tableId)" (picked)="pickOption('table', $event)" />
          <label class="audit-field">
            <span>{{ 'audit.filters.record' | translate }}</span>
            <input #rec class="p-inputtext aud-input" type="search" [value]="f.recordId ?? ''" [placeholder]="'audit.filters.recordHint' | translate" (keydown.enter)="setRecordId(rec.value)" (change)="setRecordId(rec.value)" />
          </label>
        }
        <iu-audit-option-picker class="audit-field audit-field--wide" kind="user" [label]="'audit.filters.user' | translate" [selectedName]="nameOf('user', f.userId)" (picked)="pickOption('user', $event)" />
      </div>

      @if (activeKeys().length) {
        <div class="audit-active" role="list" [attr.aria-label]="'audit.filters.active' | translate">
          @for (key of activeKeys(); track key) {
            <span class="audit-pill" role="listitem">
              <span class="audit-pill-key">{{ 'audit.filters.' + key | translate }}</span>
              <span class="audit-pill-value">{{ pillValue(key) }}</span>
              <button type="button" class="audit-pill-x" (click)="removeFilter(key)" [attr.aria-label]="('audit.filters.remove' | translate) + ' ' + ('audit.filters.' + key | translate)">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
              </button>
            </span>
          }
          <button type="button" class="aud-link-btn" (click)="clearFilters()">{{ 'audit.filters.clearAll' | translate }}</button>
        </div>
      }

      @if (listError() && listState() === 'ready') {
        <p class="aud-state aud-state--error audit-inline-error" role="alert">
          <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>{{ listError() }}
        </p>
      }

      <!-- list -->
      <div class="audit-table-wrap" data-theme="apiz-grid-theme-base" [attr.aria-busy]="listState() === 'loading'">
        @if (listState() === 'error') {
          <div class="audit-empty audit-empty--error" role="alert">
            <i class="fa-solid fa-plug-circle-exclamation" aria-hidden="true"></i>
            <strong>{{ 'audit.state.listError' | translate }}</strong>
            <span>{{ listError() }}</span>
            <button type="button" class="p-button p-button-secondary" (click)="reload()">{{ 'audit.actions.retry' | translate }}</button>
          </div>
        } @else if (f.tab === 'executions') {
          <table class="audit-table">
            <caption class="visually-hidden">{{ 'audit.tabs.executions' | translate }}</caption>
            <thead>
              <tr>
                <th scope="col" class="col-status">{{ 'audit.columns.status' | translate }}</th>
                <th scope="col">{{ 'audit.columns.process' | translate }}</th>
                <th scope="col" class="col-date">
                  <button type="button" class="audit-sort" (click)="toggleSort()" [attr.aria-label]="'audit.actions.sort' | translate">
                    {{ 'audit.columns.started' | translate }}
                    <i class="fa-solid" [class]="f.sort === 'desc' ? 'fa-arrow-down-wide-short' : 'fa-arrow-up-short-wide'" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col" class="col-num">{{ 'audit.columns.duration' | translate }}</th>
                <th scope="col" class="col-user">{{ 'audit.columns.user' | translate }}</th>
                <th scope="col" class="col-wide">{{ 'audit.columns.summary' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (listState() === 'loading' && !executions()) {
                @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                  <tr class="audit-skeleton"><td colspan="6"><span></span></td></tr>
                }
              } @else {
                @for (e of executions()?.items ?? []; track e.id) {
                  <tr
                    class="audit-row"
                    tabindex="0"
                    [class.audit-row--on]="isSelected(e.id)"
                    [attr.aria-current]="isSelected(e.id) ? 'true' : null"
                    (click)="openExecution(e)"
                    (keydown)="onRowKey($event, e)">
                    <td class="col-status">
                      <span class="aud-badge aud-badge--{{ e.status }}">
                        <i class="fa-solid" [class]="e.status === 'R' ? 'fa-circle-notch fa-spin' : e.status === 'S' ? 'fa-check' : e.status === 'F' ? 'fa-xmark' : 'fa-ban'" aria-hidden="true"></i>
                        {{ 'audit.status.' + e.status | translate }}
                      </span>
                      @if (stale(e)) {
                        <i class="fa-solid fa-triangle-exclamation audit-stale" [title]="'audit.execution.stale' | translate" [attr.aria-label]="'audit.execution.stale' | translate"></i>
                      }
                    </td>
                    <td>
                      <div class="audit-cell-main">
                        <i class="fa-solid audit-type-icon" [class]="e.type === 'R' ? 'fa-file-lines' : 'fa-gears'" [title]="('audit.type.' + e.type) | translate" aria-hidden="true"></i>
                        <span class="audit-ellipsis" [title]="e.processName">{{ e.processName }}</span>
                      </div>
                      <small class="aud-muted">#{{ e.id }}</small>
                    </td>
                    <td class="col-date" [title]="fmt().exact(e.created)">
                      {{ fmt().relative(e.created, now()) }}
                      <small class="aud-muted">{{ fmt().dateTime(e.created) }}</small>
                    </td>
                    <td class="col-num">{{ duration(e.durationMs) || '-' }}</td>
                    <td class="col-user"><span class="audit-ellipsis" [title]="e.userName ?? ''">{{ e.userName || '-' }}</span></td>
                    <td class="col-wide"><span class="audit-ellipsis audit-summary-cell" [class.audit-summary-cell--F]="e.status === 'F'" [title]="e.summary ?? ''">{{ e.summary }}</span></td>
                  </tr>
                }
              }
            </tbody>
          </table>
        } @else if (f.tab === 'documents') {
          <table class="audit-table">
            <caption class="visually-hidden">{{ 'audit.tabs.documents' | translate }}</caption>
            <thead>
              <tr>
                <th scope="col" class="col-status">{{ 'audit.columns.action' | translate }}</th>
                <th scope="col" class="col-date">
                  <button type="button" class="audit-sort" (click)="toggleSort()" [attr.aria-label]="'audit.actions.sort' | translate">
                    {{ 'audit.columns.date' | translate }}
                    <i class="fa-solid" [class]="f.sort === 'desc' ? 'fa-arrow-down-wide-short' : 'fa-arrow-up-short-wide'" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col" class="col-wide">{{ 'audit.columns.document' | translate }}</th>
                <th scope="col" class="col-user">{{ 'audit.columns.user' | translate }}</th>
                <th scope="col" class="col-num">{{ 'audit.columns.times' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (listState() === 'loading' && !documents()) {
                @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                  <tr class="audit-skeleton"><td colspan="5"><span></span></td></tr>
                }
              } @else {
                @for (a of documents()?.items ?? []; track a.id) {
                  <tr
                    class="audit-row"
                    tabindex="0"
                    [class.audit-row--on]="isSelected(a.id)"
                    [attr.aria-current]="isSelected(a.id) ? 'true' : null"
                    (click)="openAccess(a)"
                    (keydown)="onRowKey($event, a)">
                    <td class="col-status">
                      <span class="aud-badge aud-badge--doc-{{ a.action }}">
                        <i class="fa-solid" [class]="a.action === 'DOWNLOAD' ? 'fa-download' : a.action === 'VIEW' ? 'fa-eye' : 'fa-image'" aria-hidden="true"></i>
                        {{ 'audit.docAction.' + a.action | translate }}
                      </span>
                    </td>
                    <td class="col-date" [title]="fmt().exact(a.last)">
                      {{ fmt().relative(a.last, now()) }}
                      <small class="aud-muted">{{ fmt().dateTime(a.last) }}</small>
                    </td>
                    <td class="col-wide">
                      <div class="audit-cell-main">
                        <i class="fa-solid fa-file-lines audit-type-icon" aria-hidden="true"></i>
                        <span class="audit-ellipsis" [title]="a.fileName || a.docId">{{ a.fileName || a.docId }}</span>
                      </div>
                      <small class="aud-muted">{{ docChannelLabel(a) }}</small>
                    </td>
                    <td class="col-user">
                      <span class="audit-ellipsis" [title]="a.userName ?? ''">{{ a.userName || '#' + a.userId }}</span>
                      @if (a.roleName) {
                        <small class="aud-muted audit-ellipsis">{{ a.roleName }}</small>
                      }
                    </td>
                    <td class="col-num" [title]="a.count > 1 ? fmt().dateTime(a.first) + ' - ' + fmt().dateTime(a.last) : ''">{{ fmt().number(a.count) }}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        } @else {
          <table class="audit-table">
            <caption class="visually-hidden">{{ 'audit.tabs.changes' | translate }}</caption>
            <thead>
              <tr>
                <th scope="col" class="col-status">{{ 'audit.columns.operation' | translate }}</th>
                <th scope="col" class="col-date">
                  <button type="button" class="audit-sort" (click)="toggleSort()" [attr.aria-label]="'audit.actions.sort' | translate">
                    {{ 'audit.columns.date' | translate }}
                    <i class="fa-solid" [class]="f.sort === 'desc' ? 'fa-arrow-down-wide-short' : 'fa-arrow-up-short-wide'" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">{{ 'audit.columns.record' | translate }}</th>
                <th scope="col" class="col-wide">{{ 'audit.columns.fields' | translate }}</th>
                <th scope="col" class="col-user">{{ 'audit.columns.user' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (listState() === 'loading' && !changes()) {
                @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                  <tr class="audit-skeleton"><td colspan="5"><span></span></td></tr>
                }
              } @else {
                @for (c of changes()?.items ?? []; track c.id) {
                  <tr
                    class="audit-row"
                    tabindex="0"
                    [class.audit-row--on]="isSelected(c.id)"
                    [attr.aria-current]="isSelected(c.id) ? 'true' : null"
                    (click)="openChange(c)"
                    (keydown)="onRowKey($event, c)">
                    <td class="col-status"><span class="aud-badge aud-badge--op-{{ c.changeType }}">{{ opKey(c.changeType) | translate }}</span></td>
                    <td class="col-date" [title]="fmt().exact(c.created)">
                      {{ fmt().relative(c.created, now()) }}
                      <small class="aud-muted">{{ fmt().dateTime(c.created) }}</small>
                    </td>
                    <td>
                      <div class="audit-cell-main">
                        <span class="audit-ellipsis" [title]="c.recordName || recordLabel(c.recordId)">{{ c.recordName || recordLabel(c.recordId) }}</span>
                      </div>
                      <small class="aud-muted">{{ c.tableLabel || c.tableName || ('#' + c.tableId) }}</small>
                    </td>
                    <td class="col-wide">
                      <span class="audit-ellipsis">{{ fieldsPreview(c) }}</span>
                      @if (c.changeCount > 3) {
                        <small class="aud-muted"> +{{ c.changeCount - 3 }}</small>
                      }
                    </td>
                    <td class="col-user"><span class="audit-ellipsis" [title]="c.userName ?? ''">{{ c.userName || ('#' + c.userId) }}</span></td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }

        @if (listState() === 'ready' && page()?.total === 0) {
          <div class="audit-empty">
            <i class="fa-solid" [class]="activeKeys().length ? 'fa-filter-circle-xmark' : 'fa-inbox'" aria-hidden="true"></i>
            @if (activeKeys().length) {
              <strong>{{ 'audit.state.noResults' | translate }}</strong>
              <button type="button" class="p-button p-button-secondary" (click)="clearFilters()">{{ 'audit.filters.clearAll' | translate }}</button>
            } @else {
              <strong>{{ (f.tab === 'executions' ? 'audit.state.noExecutions' : f.tab === 'changes' ? 'audit.state.noChanges' : 'audit.state.noDocuments') | translate }}</strong>
              <span>{{ 'audit.state.widenPeriod' | translate }}</span>
            }
          </div>
        }
      </div>

      <!-- paging -->
      @if (pageInfo(); as info) {
        <nav class="audit-pager" [attr.aria-label]="'audit.paging.label' | translate">
          <span>{{ 'audit.paging.range' | translate: { from: fmt().number(info.from), to: fmt().number(info.to), total: fmt().number(info.total) } }}</span>
          <label class="audit-page-size">
            <span>{{ 'audit.paging.size' | translate }}</span>
            <select class="p-inputtext aud-input" [value]="f.pageSize" (change)="setPageSize($any($event.target).value)">
              @for (n of pageSizes; track n) {
                <option [value]="n">{{ n }}</option>
              }
            </select>
          </label>
          <button type="button" class="aud-icon-btn" [disabled]="f.page === 0" (click)="setPage(0)" [attr.aria-label]="'audit.paging.first' | translate">
            <i class="fa-solid fa-angles-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="aud-icon-btn" [disabled]="f.page === 0" (click)="setPage(f.page - 1)" [attr.aria-label]="'audit.paging.previous' | translate">
            <i class="fa-solid fa-angle-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="aud-icon-btn" [disabled]="!hasNext()" (click)="setPage(f.page + 1)" [attr.aria-label]="'audit.paging.next' | translate">
            <i class="fa-solid fa-angle-right" aria-hidden="true"></i>
          </button>
        </nav>
      }
    </section>

    <!-- detail panel: keeps the list and its filters in place -->
    @if (detailOpen()) {
      <aside class="audit-detail" role="dialog" [attr.aria-label]="'audit.detail' | translate" (keydown.escape)="closeDetail()">
        @if (selectedExecution(); as row) {
          <iu-audit-execution-detail
            [row]="row"
            [detail]="executionDetail()"
            [loading]="detailLoading()"
            [error]="detailError()"
            [fmt]="fmt()"
            [now]="now()"
            (closed)="closeDetail()"
            (retry)="retryDetail()"
            [canStop]="canStop"
            [stopping]="stoppingId() === row.id"
            [stopNote]="stopNote()?.id === row.id ? stopNote()!.note : null"
            (stop)="stopExecution($event)"
            (showChanges)="executionChanges($event)"
            (openRun)="openRun($event)"
            (filterProcess)="executionsOfProcess($event)"
            (filterUser)="byUser('executions', $event.userId, $event.userName)" />
        } @else if (selectedChange()) {
          <iu-audit-change-detail
            [change]="selectedChange()"
            [loading]="detailLoading()"
            [error]="detailError()"
            [fmt]="fmt()"
            (closed)="closeDetail()"
            (retry)="retryDetail()"
            (openRecord)="openRecord($event)"
            (filterRecord)="recordHistory($event)"
            (filterSession)="sessionChanges($event)"
            (filterUser)="byUser('changes', $event.userId, $event.userName)" />
        } @else if (selectedAccess()) {
          <iu-audit-document-detail
            [access]="selectedAccess()"
            [fmt]="fmt()"
            (closed)="closeDetail()"
            (filterDocument)="documentReads($event)"
            (filterUser)="byUser('documents', $event.userId, $event.userName)" />
        }
      </aside>
    }
  </div>
</div>
